import React from 'react'
import { CustomCTAProps } from '../OTLContentSections/CustomCTA/CustomCTA.d'
import { GeneralBodyProps } from '../OTLContentSections/GeneralBody/GeneralBody.d'
import { PromoBlock } from '../OTLContentSections/PromoBlock/PromoBlock.d'
import { TechTipProps } from '../OTLContentSections/TechTips/TechTips.d'
import GatedCTALongForm from '../OTLContentSections/GatedCTALongForm/GatedCTALongForm'
import PromoBlockModule from '../OTLContentSections/PromoBlock/PromoBlock'
import UngatedCtaShortForm from '../OTLContentSections/UngatedCtaShortForm/UngatedCtaShortForm'
import { UngatedCtaShortFormProps } from '../OTLContentSections/UngatedCtaShortForm/UngatedCtaShortForm.d'
import { GatedCTALongFormProps } from '../OTLContentSections/GatedCTALongForm/GatedCTALongForm.d'
import { OnTheLineModulesProps } from './OnTheLineModules.d'
import { FeaturedArticleProps } from '../OTLContentSections/FeaturedArticle/FeaturedArticle.d'
import RelatedArticles from '../OTLContentSections/RelatedArticles/RelatedArticles'
import { RelatedArticlesProps } from '../OTLContentSections/RelatedArticles/RelatedArticles.d'
import ContentWarningModule from '../OTLContentSections/ContentWarning/ContentWarning'
import { ContentWarning } from '../OTLContentSections/ContentWarning/ContentWarning.d'
import { HowToCTAProps } from '../OTLContentSections/HowToCTA/HowToCTA.d'
import { Blockquote } from '../OTLContentSections/Blockquote/Blockquote.d'
import BlockquoteModule from '../OTLContentSections/Blockquote/Blockquote'
import { BarGraphProps } from '../OTLContentSections/BarGraph/BarGraph.d'
import BarGraphModule from '../OTLContentSections/BarGraph/BarGraph'
import VidyardVideoPlayer from '../OTLContentSections/VidyardVideo/VidyardVideoPlayer'
import { VidyardVideoPlayerProps } from '../OTLContentSections/VidyardVideo/VidyardVideo.d'
import { PodcastEmbedProps } from '../OTLContentSections/PodcastEmbed/PodcastEmbed.d'
import PodcastEmbed from '../OTLContentSections/PodcastEmbed/PodcastEmbed'
import { NewsletterSubscribeProps } from '../OTLContentSections/NewsletterSubscribe/NewsletterSubscribe.d'
import CustomCTAModule from '../OTLContentSections/CustomCTA/CustomCTA'
import GeneralBodyModule from '../OTLContentSections/GeneralBody/GeneralBody'
import { InfogramEmbedProps } from '@toasttab/shared/src/components/molecules/InfogramEmbed/InfogramEmbed.d'
import InfogramEmbed from '@toasttab/shared/src/components/molecules/InfogramEmbed/InfogramEmbed'
import { FeaturedSnippetProps } from '../OTLContentSections/FeaturedSnippet/FeaturedSnippet.d'
import FeaturedSnippetModule from '../OTLContentSections/FeaturedSnippet/FeaturedSnippet'
import { LinkCTAProps } from '../OTLContentSections/LinkCTA/LinkCTA.d'
import ProductCTA from '../OTLContentSections/ProductCTA/ProductCTA'
import { ProductCTAProps } from '../OTLContentSections/ProductCTA/ProductCTA.d'
import TechTipModule from '../OTLContentSections/TechTips/TechTips'
import RetailCTAModule from '@toasttab/otl/src/components/PageModules/OTLContentSections/RetailCTA/RetailCTA'
import KeyTakeaways from '@toasttab/shared/src/components/molecules/KeyTakeaways/KeyTakeaways'
import { KeyTakeawaysProps } from '@toasttab/shared/src/components/molecules/KeyTakeaways/KeyTakeaways.d'

const OnTheLineModules = ({
  entryId,
  formCategory,
  onTheLineModules,
  displayOnSideBar,
  displayOnHero,
  backgroundColor,
  otlHeroCtaCopy,
  isPreview = false
}: OnTheLineModulesProps) => {
  const renderPreviewInfo = (internalName: string) => {
    return (
      <div className='pt-8 font-bold italic text-red-500'>
        <hr className='pb-4' />
        {internalName}
      </div>
    )
  }

  const renderModule = ({
    entryId,
    onTheLineModules,
    displayOnSideBar,
    displayOnHero
  }: OnTheLineModulesProps) => {
    if (displayOnSideBar) {
    } else {
      return (
        onTheLineModules &&
        onTheLineModules.map(
          (
            module:
              | BarGraphProps
              | Blockquote
              | ContentWarning
              | CustomCTAProps
              | FeaturedArticleProps
              | FeaturedSnippetProps
              | GatedCTALongFormProps
              | GeneralBodyProps
              | HowToCTAProps
              | InfogramEmbedProps
              | KeyTakeawaysProps
              | LinkCTAProps
              | NewsletterSubscribeProps
              | PodcastEmbedProps
              | ProductCTAProps
              | PromoBlock
              | RelatedArticlesProps
              | TechTipProps
              | UngatedCtaShortFormProps
              | VidyardVideoPlayerProps
          ) => {
            if (!module) return null
            const typeHandle = module.__typename
            switch (typeHandle) {
              case 'ContentfulContentWarning': {
                return (
                  <>
                    {isPreview && renderPreviewInfo(module.internalName)}
                    <ContentWarningModule
                      {...(module as ContentWarning)}
                      key={module.contentful_id}
                    />
                  </>
                )
              }
              case 'ContentfulGeneralBody': {
                const gb = module as GeneralBodyProps
                return (
                  <>
                    {isPreview && renderPreviewInfo(module.internalName)}
                    <GeneralBodyModule
                      {...gb}
                      entryId={entryId}
                      key={module.contentful_id}
                    />
                  </>
                )
              }
              case 'ContentfulGatedCtaShortForm': {
                return (
                  <>
                    {isPreview && renderPreviewInfo(module.internalName)}
                    <section className='otl-custom-cta z-10 mb-10'>
                      <UngatedCtaShortForm
                        key={module.contentful_id}
                        {...(module as UngatedCtaShortFormProps)}
                      />
                    </section>
                  </>
                )
              }
              case 'ContentfulGatedCtaLongForm': {
                const form = module as GatedCTALongFormProps
                return (
                  <>
                    {isPreview && renderPreviewInfo(module.internalName)}
                    <section className='otl-custom-cta z-10 mb-10'>
                      <GatedCTALongForm
                        key={module.contentful_id}
                        entryId={entryId}
                        variation={
                          displayOnHero ? 'default' : 'orange-illustration'
                        }
                        {...form}
                      />
                    </section>
                  </>
                )
              }
              case 'ContentfulPromoBlock': {
                const promoBlock = module as PromoBlock
                promoBlock.displayOnHero = displayOnHero // when display on Hero, show footer (toast build for you)
                if (displayOnHero) {
                  promoBlock.blockDescription.blockDescription = otlHeroCtaCopy
                }
                return (
                  <>
                    {isPreview && renderPreviewInfo(module.internalName)}
                    <section className='otl-custom-cta z-10 mb-10'>
                      <PromoBlockModule
                        key={module.contentful_id}
                        {...(module as PromoBlock)}
                      />
                    </section>
                  </>
                )
              }
              case 'ContentfulBlockQuote': {
                return (
                  <>
                    {isPreview && renderPreviewInfo(module.internalName)}
                    <BlockquoteModule
                      {...(module as Blockquote)}
                      key={module.contentful_id}
                    />
                  </>
                )
              }
              case 'ContentfulBarGraph': {
                return (
                  <>
                    {isPreview && renderPreviewInfo(module.internalName)}
                    <BarGraphModule
                      {...(module as BarGraphProps)}
                      key={module.contentful_id}
                    />
                  </>
                )
              }
              case 'ContentfulVidYardVideoPlayer': {
                return (
                  <>
                    {isPreview &&
                      renderPreviewInfo(
                        'Vidyard Video - ' +
                          (module as VidyardVideoPlayerProps).vidyardId
                      )}
                    <VidyardVideoPlayer
                      {...(module as VidyardVideoPlayerProps)}
                      key={module.contentful_id}
                    />
                  </>
                )
              }
              case 'ContentfulInfogramEmbed': {
                return (
                  <>
                    {isPreview && renderPreviewInfo(module.internalName)}
                    <InfogramEmbed
                      {...(module as InfogramEmbedProps)}
                      key={module.contentful_id}
                    />
                  </>
                )
              }
              case 'ContentfulTechTips': {
                const techTip = module as TechTipProps
                return (
                  <>
                    {isPreview && renderPreviewInfo(module.internalName)}
                    <TechTipModule {...techTip} key={module.contentful_id} />
                  </>
                )
              }
              case 'ContentfulFeaturedSnippet': {
                return (
                  <>
                    {isPreview && renderPreviewInfo(module.internalName)}
                    <FeaturedSnippetModule
                      {...(module as FeaturedSnippetProps)}
                      key={module.contentful_id}
                    />
                  </>
                )
              }
              case 'ContentfulRelatedArticles': {
                const relatedArticles = module as RelatedArticlesProps
                return (
                  !relatedArticles.addToSidebar &&
                  !relatedArticles.displayAsTrendingArticles && (
                    <>
                      {isPreview && renderPreviewInfo(module.internalName)}
                      <RelatedArticles
                        key={module.contentful_id}
                        heading='Read more'
                        relatedArticles={relatedArticles.relatedArticles}
                        layout={'horizontal'}
                        fullWidth={false}
                        scrollingMode='normal'
                        id={''}
                        addToSidebar={false}
                        __typename={relatedArticles.__typename}
                      />
                    </>
                  )
                )
              }
              case 'ContentfulRetailCta': {
                return (
                  <>
                    {isPreview && renderPreviewInfo(module.internalName)}
                    <RetailCTAModule />
                  </>
                )
              }
              case 'ContentfulKeyTakeaways': {
                const keyTakeaway = module as KeyTakeawaysProps
                return (
                  <>
                    {isPreview && renderPreviewInfo(module.internalName)}
                    <KeyTakeaways
                      heading={
                        keyTakeaway.heading as KeyTakeawaysProps['heading']
                      }
                      key={keyTakeaway.contentful_id}
                      keyTakeaways={keyTakeaway.keyTakeaways}
                      uniqueId={keyTakeaway.uniqueId}
                    />
                  </>
                )
              }
              case 'ContentfulProductCta': {
                const productCta = module as ProductCTAProps
                return (
                  <>
                    {isPreview && renderPreviewInfo(module.internalName)}
                    <ProductCTA
                      {...productCta}
                      key={productCta.contentful_id}
                    />
                  </>
                )
              }
              default: {
                return <></>
              }
            }
          }
        )
      )
    }
  }
  return (
    <>
      {renderModule({
        entryId,
        onTheLineModules,
        displayOnSideBar,
        displayOnHero,
        backgroundColor,
        formCategory
      })}
    </>
  )
}

export default OnTheLineModules
